export const validateUrl = (url) => {
  // Regex to check for a valid URL with paths
  const pattern =
    /^https:\/\/www\.[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z0-9-]+)?(?:\/[^\s]*)?$/;
  return url && pattern.test(url);
};
